import { render } from "./TheContacts.vue?vue&type=template&id=63611b05&ts=true"
import script from "./TheContacts.vue?vue&type=script&lang=ts"
export * from "./TheContacts.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__